import { Button } from 'antd';
import classes from './DeleteButton.module.scss';
import { useReadOnly } from '../../../hooks/useReadOnly';

export const DeleteButton = ({ onDelete }) => {
    const readOnly = useReadOnly();

    return (
        <Button onClick={onDelete} className={classes['delete-button']} disabled={readOnly}>
            <i className={`fi-rr-trash ${classes['delete-icon']}`} />
        </Button>
    );
};
